/* ------------------------------------------------ os nomes das lições ---
   O conteúdo da Trilha nasceu sem nome de lição: uma lição é só "a fatia N
   de cinco pílulas" que `licoesDe` corta de cada seção. Servia enquanto o
   mapa era uma coluna de círculos anônimos; deixou de servir quando o mapa
   passou a mostrar o rótulo de cada nó — "Lição 3" não diz a ninguém o que
   vem pela frente nem o que já ficou para trás.

   Cada título abaixo foi escrito lendo as cinco perguntas da fatia
   correspondente, não o título da seção. Por isso alguns fogem do óbvio: a
   lição 7 de "modalidades" não é "mais modalidades", é a revisão aplicada
   que de fato fecha a seção.

   A chave é o slug da seção; o índice do array é o índice da lição. Se o
   conteúdo de `data/` for refatiado (mudar PILULAS_POR_LICAO, inserir
   pílula no meio), estes nomes saem do lugar SILENCIOSAMENTE — o teste do
   módulo confere o comprimento de cada lista contra o conteúdo real para
   transformar esse desalinhamento em quebra visível.

   Última lição de cada seção: quando as cinco perguntas são casos aplicados
   que misturam a seção inteira (o padrão dominante do conteúdo), o nome é
   "Recapitulação da seção", que é também o nó-troféu do mapa. Quando a
   fatia final tem tema próprio, ela recebe o nome do tema — mentir
   "recapitulação" onde há assunto novo esconderia conteúdo. */
export const TITULOS_DAS_LICOES: Record<string, string[]> = {
    /* ------------------------------------------ trilha: fundamentos --- */
    fundamentos: [
        'A quem a lei se aplica',
        'Os objetos da lei',
        'O que fica de fora',
        'Os princípios do art. 5º',
        'Princípios na prática',
        'Objetivos do processo',
        'Regras complementares',
        'Recapitulação da seção',
    ],
    definicoes: [
        'O vocabulário da lei',
        'Comum, especial e contínuo',
        'Os documentos técnicos',
        'Agentes e conceitos-chave',
        'Riscos e regimes integrados',
        'Procedimentos auxiliares',
        'Sobrepreço e superfaturamento',
        'Recapitulação da seção',
    ],
    agentes: [
        'Quem conduz a licitação',
        'Requisitos e impedimentos',
        'Responsabilidade dos agentes',
        'As vedações do art. 9º',
        'Vedações e apoio técnico',
        'O plano de contratações anual',
        'Forma e formalismo dos atos',
        'Recapitulação da seção',
    ],
    modalidades: [
        'O mapa das modalidades',
        'Pregão',
        'Concorrência',
        'Concurso',
        'Leilão',
        'Diálogo competitivo',
        'Diálogo competitivo na prática',
        'Recapitulação da seção',
    ],
    preparatoria: [
        'Para que serve o ETP',
        'O conteúdo do ETP',
        'ETP: o que não pode faltar',
        'Termo de referência',
        'Marca, amostra e padronização',
        'Do anteprojeto ao executivo',
        'Regimes de execução',
        'Recapitulação da seção',
    ],
    precos: [
        'Como se estima o preço',
        'Os parâmetros na prática',
        'A IN SEGES 65/2021',
        'Do preço coletado ao estimado',
        'O relatório da pesquisa',
        'Orçamento sigiloso',
        'Sobrepreço e preço na direta',
        'Recapitulação da seção',
    ],
    edital: [
        'O edital e suas regras',
        'PNCP e publicidade',
        'Prazos de divulgação',
        'Prazos: casos aplicados',
        'Alterações e prazos especiais',
        'Impugnação e esclarecimento',
        'Participação e controle prévio',
        'Recapitulação da seção',
    ],
    julgamento: [
        'Os critérios de julgamento',
        'Técnica e preço',
        'Modos de disputa',
        'Lances e garantia de proposta',
        'Desclassificação e inexequibilidade',
        'Critérios de desempate',
        'Negociação e retorno econômico',
        'Recapitulação da seção',
    ],
    habilitacao: [
        'O que é a habilitação',
        'Habilitação jurídica e declarações',
        'Qualificação técnica',
        'Atestados na prática',
        'Regularidade fiscal e trabalhista',
        'Qualificação econômico-financeira',
        'Diligências e vistoria',
        'Registro cadastral e limites',
    ],
    direta: [
        'Dispensa ou inexigibilidade?',
        'As hipóteses de inexigibilidade',
        'Exclusividade e notória especialização',
        'Dispensa por valor',
        'Emergência e outras dispensas',
        'Dispensas em espécie',
        'Cautelas da contratação direta',
        'Recapitulação da seção',
    ],
    contratos: [
        'A forma do contrato',
        'Assinatura e cláusulas essenciais',
        'Garantias contratuais',
        'Seguro-garantia e retomada',
        'Duração dos contratos',
        'Vigências especiais',
        'As prerrogativas da Administração',
        'Nulidade do contrato',
    ],
    execucao: [
        'Quem responde pela execução',
        'Alterações e seus limites',
        'Reajuste, repactuação e revisão',
        'Pagamentos',
        'Recebimento do objeto',
        'Fiscal, encargos e subcontratação',
        'Extinção do contrato',
        'Recapitulação da seção',
    ],
    sancoes: [
        'As quatro sanções',
        'Impedimento e inidoneidade',
        'Quem pune e como',
        'Defesa e prescrição',
        'Desconsideração e cadastros',
        'Reabilitação',
        'As três linhas de defesa',
        'Controle externo e cautelares',
    ],
    especiais: [
        'ME e EPP: os benefícios',
        'ME e EPP na prática',
        'Sustentabilidade e preferências',
        'O PNCP em detalhe',
        'Crimes em licitações',
        'Crimes em espécie',
        'Registro de preços',
        'Adesão à ata (carona)',
    ],
    /* ----------------------------------------- trilha: especialista --- */
    'esp01-constitucional': [
        'O dever constitucional de licitar',
        'Formalidade e finalidade',
        'Competência para legislar',
        'As estatais e a 13.303',
        'As zonas de fronteira',
        'A transição de regimes',
        'Controvérsias da transição',
        'Regulamentos e casos-limite',
    ],
    'esp02-principios': [
        'Princípios sob tensão',
        'Competitividade e isonomia',
        'Eficiência e economicidade',
        'Vinculação ao edital',
        'Saneamento e julgamento objetivo',
        'O teste da proporcionalidade',
        'Motivação e segregação',
        'Confiança e segurança jurídica',
    ],
    'esp03-inexigibilidade': [
        'O processo da contratação direta',
        'O preço na contratação direta',
        'Ritos e cautelas',
        'Fornecedor exclusivo',
        'A prova da exclusividade',
        'A contratação de artistas',
        'Singularidade em debate',
        'Credenciamento',
    ],
    'esp04-dispensa': [
        'Licitação deserta e fracassada',
        'A emergência e suas causas',
        'Emergência: prazos e limites',
        'Segurança e defesa',
        'Pesquisa e inovação',
        'Entidades e cooperativas',
        'Dispensas em alienações',
        'Permuta e investidura',
    ],
    'esp05-regulatoria': [
        'A função regulatória',
        'ME e EPP: enquadramento',
        'Os limites do benefício',
        'Empate ficto e regularização',
        'Preferências em cada rito',
        'A cota reservada',
        'Quando afastar a exclusividade',
        'Margens de preferência',
    ],
    'esp06-preparatoria': [
        'O PCA sob fiscalização',
        'O ETP em casos difíceis',
        'Projetos e suas exigências',
        'A estimativa e seus usos',
        'Orçamentos especiais',
        'Orçamento e imprevistos',
        'Integrada e semi-integrada',
        'A matriz de riscos',
    ],
    'esp07-agentes': [
        'Competências e seus limites',
        'A designação dos agentes',
        'Pregoeiro e comissão',
        'Quem responde pelo quê',
        'Erro grosseiro e culpa grave',
        'A LINDB no controle',
        'O parecer jurídico',
        'A responsabilidade do parecerista',
    ],
    /* --------------------------------------------- trilha: polêmicas --- */
    'pol01-habilitacao': [
        'Exigências que restringem',
        'Parcelas de maior relevância',
        'Quantitativos e experiência',
        'De quem é o atestado?',
        'Consórcios',
        'Cooperativas e conflitos',
        'O alcance das sanções',
        'Balanços e índices',
    ],
    'pol02-julgamento': [
        'A escolha da modalidade',
        'Diálogo competitivo na prática',
        'Fases e modos de disputa',
        'Erros e juntadas tardias',
        'A proposta inexequível',
        'Negociação e orçamento sigiloso',
        'Desempates difíceis',
        'Impugnações e recursos',
    ],
    'pol03-srp': [
        'O que a ata garante',
        'Montando o SRP',
        'IRP e participantes',
        'A vida útil da ata',
        'Preços da ata em movimento',
        'Ata: incidentes de percurso',
        'O carona em debate',
        'Os limites da adesão',
    ],
    'pol04-contratos': [
        'Da homologação à assinatura',
        'A decisão sobre garantias',
        'A garantia em movimento',
        'A cláusula de retomada',
        'Forma e cláusulas exorbitantes',
        'Divulgação no PNCP',
        'Duração e orçamento',
        'Prorrogações e vigências',
    ],
    'pol05-execucao': [
        'O fiscal e seus riscos',
        'Subcontratação e cessão',
        'Recebimento e responsabilidade',
        'Pagamentos e retenções',
        'Inadimplências e reações',
        'Até onde vai o aditivo',
        'Os limites de 25% e 50%',
        'Erros de projeto e itens novos',
    ],
    'pol06-equilibrio': [
        'Reajuste: teses e prazos',
        'Repactuação',
        'Revisão e imprevisão',
        'Fato do príncipe e riscos',
        'Anulação e seus efeitos',
        'Extinção sem culpa',
        'Sanções: dosimetria e alcance',
        'Inidoneidade e reabilitação',
    ],
    /* ---------------------------------------- trilha: jurisprudência --- */
    'jur01-tcu-licitacao': [
        'Habilitação: o que o TCU veda',
        'Atestados e seus limites',
        'Índices econômicos no edital',
        'Participação e impedimentos',
        'Modalidade e objeto',
        'Orçamento e preços',
        'Diligência e saneamento',
        'Pregão: casos julgados',
    ],
    'jur02-tcu-contratos': [
        'Inexigibilidade no TCU',
        'Emergência no TCU',
        'Carona e registro de preços',
        'Aditivos e seus limites',
        'O jogo de planilha',
        'Reequilíbrio no TCU',
        'Fiscalização e pagamentos',
        'Fraudes e sanções',
    ],
    'jur03-stf-stj': [
        'Conselhos e OAB',
        'Terceiro setor',
        'Leis locais no STF',
        'Encargos da terceirização',
        'Contrato nulo e seus efeitos',
        'Mandado de segurança',
        'Os poderes do TCU',
        'Anulação e revogação',
    ],
}

/* Fallback deliberadamente pobre: se a seção não tem lista (conteúdo novo
   ainda sem batismo) ou a fatia passou do fim dela, volta o "Lição N" — que
   é feio de propósito, para ser notado e corrigido, em vez de um título de
   outra lição no lugar errado. */
export function tituloDaLicao(slug: string, indice: number): string {
    return TITULOS_DAS_LICOES[slug]?.[indice] ?? `Lição ${indice + 1}`
}
